import vars from '../helpers';

$('.up a').on('click', (e) => {
	let currentOffset = vars.$body.offset().top - 100;

	const scrollContainer = window.Scrollbar.get($('.js-scroller').get(0));

	e.preventDefault();
	if (scrollContainer) {
		scrollContainer.scrollTo(0, currentOffset, 1500);
	} else {
		vars.scrollTo(vars.$body);
	}
});
